import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { CharacterCard, CharacterCardSkeleton } from '../components/CharacterCard';
import { Button } from '../components/ui/button';
import { Bookmark, Sparkles, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function Collection() {
  const { user } = useAuth();
  const [characters, setCharacters] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      fetchCollection();
    }
  }, [user]);

  const fetchCollection = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/api/user/collection`, {
        withCredentials: true
      });
      setCharacters(data);
    } catch (error) {
      console.error('Error fetching collection:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4">
        <div className="text-center">
          <Bookmark className="w-16 h-16 text-[#71717A] mx-auto mb-4" />
          <h2 className="text-xl font-bold text-white mb-2">Sign in to view collection</h2>
          <p className="text-[#71717A] mb-6">Save your favorite characters</p>
          <Link to="/login">
            <Button className="bg-[#E11D48] hover:bg-[#BE123C] text-white rounded-full px-8">
              Sign In
            </Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      {/* Header */}
      <div className="px-4 py-4">
        <h1 className="text-2xl font-bold text-white font-['Unbounded']">My Collection</h1>
        <p className="text-sm text-[#71717A] mt-1">Characters you've saved</p>
      </div>

      {loading ? (
        <div className="px-4">
          <div className="grid grid-cols-2 gap-3">
            {[...Array(4)].map((_, i) => (
              <CharacterCardSkeleton key={i} />
            ))}
          </div>
        </div>
      ) : characters.length === 0 ? (
        <div className="text-center py-16 px-4">
          <div className="w-20 h-20 rounded-full bg-[#1A1D24] flex items-center justify-center mx-auto mb-4">
            <Bookmark className="w-10 h-10 text-[#71717A]" />
          </div>
          <h3 className="text-lg font-medium text-white mb-2">No characters collected</h3>
          <p className="text-sm text-[#71717A] mb-6">Tap the bookmark icon on any character to add them here</p>
          <Link to="/">
            <Button className="bg-[#E11D48] hover:bg-[#BE123C] text-white rounded-full">
              <Sparkles className="w-4 h-4 mr-2" />
              Browse Characters
            </Button>
          </Link>
        </div>
      ) : (
        <div className="px-4">
          <div className="grid grid-cols-2 gap-3">
            {characters.map((character) => (
              <CharacterCard key={character.id} character={character} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
